<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[{text: 'Home', disable: false, href: '/#/'}, {text: 'Products', disable: false, href: '/#/products'}, {text: product.name, disabled: true}]"
            divider="/"
            class="pb-0"
        ></v-breadcrumbs>

        <ProductDetailComponent
            :productNodeId="$route.params.id"
            v-on:item-fetched="onProductFecthed"
            v-on:item-deleted="onProductDeleted"
        ></ProductDetailComponent>
    </v-container>
</template>

<script>
import ProductDetailComponent from "@/components/products/ProductDetailComponent.vue";

export default {
    name: "product-detail-page",
    components: {
        ProductDetailComponent
    },
    data() {
        return {
            product: {}
        };
    },
    computed: {},
    watch: {},
    created() {
    },
    methods: {
        onProductFecthed(response) {
            this.product = response;
        },
        onProductDeleted() {
            // redirect to products list page
            this.$router.push("/products");
        }
    }
};
</script>